import React from "react";
import "./Contact.css";
import SEO from "../../components/SEO";
import {
    FaEnvelope,
    FaMapMarkerAlt,
    FaPhoneAlt,
    FaRegClock,
} from "react-icons/fa";

function Contact() {
    return (
        <>
            <SEO
                title="Contact MICO Pool Design and Consulting"
                description="Contact MICO Pool Design and Consulting to start planning your custom pool, patio, outdoor kitchen, stucco, or yardscape design."
            />
            <div className="contact-page">
                <section className="contact-intro">
                    <p className="contact-eyebrow">Start a project</p>
                    <h1>Let us shape the backyard around the way you live.</h1>
                    <p>
                        Share a few details about your pool, patio, kitchen,
                        stucco, or yardscape design. MICO will follow up to talk
                        through scope, inspiration, and next steps.
                    </p>
                    <div className="contact-info-grid">
                        <a
                            className="contact-info-item"
                            href="tel:18327949995"
                        >
                            <FaPhoneAlt aria-hidden="true" />
                            <span>
                                <strong>Call</strong>
                                832-794-9995
                            </span>
                        </a>
                        <a
                            className="contact-info-item"
                            href="mailto:michael.pools@yahoo.com"
                        >
                            <FaEnvelope aria-hidden="true" />
                            <span>
                                <strong>Email</strong>
                                michael.pools@yahoo.com
                            </span>
                        </a>
                        <div className="contact-info-item">
                            <FaMapMarkerAlt aria-hidden="true" />
                            <span>
                                <strong>Based in</strong>
                                Houston, TX
                            </span>
                        </div>
                        <div className="contact-info-item">
                            <FaRegClock aria-hidden="true" />
                            <span>
                                <strong>Response</strong>
                                Usually within 1 business day
                            </span>
                        </div>
                    </div>
                </section>
                <div className="contact-form-container">
                    <div className="contact-form-heading">
                        <p className="contact-eyebrow">Project details</p>
                        <h2>Tell us what you are planning</h2>
                    </div>
                    <form
                        name="contact v1"
                        method="POST"
                        data-netlify="true"
                        data-netlify-honeypot="bot-field"
                        className="contact-form"
                    >
                        <input
                            type="hidden"
                            name="form-name"
                            value="contact v1"
                        />
                        <div hidden>
                            <input name="bot-field" />
                        </div>
                        <div className="contact-field-row">
                            <label>
                                Name
                                <input
                                    type="text"
                                    name="name"
                                    placeholder="Your name"
                                    required
                                />
                            </label>
                            <label>
                                Email
                                <input
                                    type="email"
                                    name="email"
                                    placeholder="you@example.com"
                                    required
                                />
                            </label>
                        </div>
                        <div className="contact-field-row">
                            <label>
                                Phone
                                <input
                                    type="tel"
                                    name="phone"
                                    placeholder="Best number to reach you"
                                />
                            </label>
                            <label>
                                Project location
                                <input
                                    type="text"
                                    name="location"
                                    placeholder="City or neighborhood"
                                />
                            </label>
                        </div>
                        <fieldset className="contact-project-options">
                            <legend>Interested in</legend>
                            <label>
                                <input
                                    type="checkbox"
                                    name="interest"
                                    value="Pool design"
                                />
                                Pool design
                            </label>
                            <label>
                                <input
                                    type="checkbox"
                                    name="interest"
                                    value="Patio"
                                />
                                Patio
                            </label>
                            <label>
                                <input
                                    type="checkbox"
                                    name="interest"
                                    value="Outdoor kitchen"
                                />
                                Outdoor kitchen
                            </label>
                            <label>
                                <input
                                    type="checkbox"
                                    name="interest"
                                    value="Yardscape"
                                />
                                Yardscape
                            </label>
                        </fieldset>
                        <label>
                            Message
                            <textarea
                                name="message"
                                rows="6"
                                placeholder="Tell us about your goals, timeline, lot details, or style inspiration."
                                required
                            ></textarea>
                        </label>
                        <button type="submit">Send message</button>
                    </form>
                </div>
            </div>
        </>
    );
}

export default Contact;
